export default __webpack_public_path__ + "static/media/r7.312572e7.jpg";